var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7814 29.4004H13.6861C6.3546 29.4004 2.68885 29.4004 1.33797 27.0158C-0.0129166 24.6312 1.86205 21.4701 5.61199 15.148L8.65963 10.0098C12.2617 3.93687 14.0628 0.900391 16.7337 0.900391C19.4046 0.900391 21.2057 3.93687 24.8078 10.0098L27.8555 15.148C31.6054 21.4701 33.4804 24.6312 32.1295 27.0158C30.7786 29.4004 27.1129 29.4004 19.7814 29.4004Z",
    fill: "white",
    stroke: "#C62828",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7344 10.4004V17.5254",
    stroke: "#C62828",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7344 23.0547V23.0712",
    stroke: "#C62828",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.231d8944c182a73990d66fc951783fa4.svg";
export { ForwardRef as ReactComponent };